import { compose, legacy_createStore as createStore } from 'redux';

import { ToastOptions } from 'react-toastify';
import reducers from './reducers';

const initialState = {};
declare global {
    interface Window {
        __REDUX_DEVTOOLS_EXTENSION_COMPOSE__?: typeof compose;
        toast: {
            dismiss: () => void;
            success: (message: string, options?: ToastOptions) => void;
            error: (message: string, options?: ToastOptions) => void;
            warn: (message: string, options?: ToastOptions) => void;
            info: (message: string, options?: ToastOptions) => void;
        };
    }
}

let composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

/**
 * comment out code below to enable Redux Devtools
 */
if (window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__) {
    // @ts-ignore
    composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({});
}

// @ts-ignore
const store = createStore(reducers, initialState, composeEnhancers());

export default store;
